<template>
  <div
    class="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden"
  >
    <!-- Header -->
    <div
      v-if="title || $slots.header"
      class="px-6 py-4 border-b border-gray-100"
    >
      <slot name="header">
        <div class="flex items-center justify-between">
          <h3 class="text-lg font-semibold text-gray-800">{{ title }}</h3>
          <div v-if="$slots.action" class="flex items-center space-x-2">
            <slot name="action"></slot>
          </div>
        </div>
      </slot>
    </div>

    <!-- Content -->
    <div class="p-6">
      <slot></slot>
    </div>

    <!-- Footer -->
    <div
      v-if="$slots.footer"
      class="px-6 py-4 bg-gray-50 border-t border-gray-100"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardCard",
  props: {
    title: {
      type: String,
      default: null
    }
  }
};
</script>
